import {
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { formatConnectedAccount } from "Components/Banking/AccountSelectionDialog/utils";
import type { BankAccountListItem } from "Infrastructure/Api/Api";

type Props = {
  accounts: Array<BankAccountListItem>;
  selectedAccountIds: Array<number>;
  onAccountChange: (accountId: number) => void;
};

export const ConnectedAccountsList = ({
  accounts,
  selectedAccountIds,
  onAccountChange,
}: Props) => (
  <List
    sx={{ ml: 4, pt: 0, display: "flex", flexDirection: "column", gap: [2, 0] }}
  >
    {accounts.map((account) => {
      const { bankAccountID } = account;
      return (
        <ListItem key={bankAccountID} disablePadding>
          <FormControlLabel
            sx={{ width: "100%" }}
            control={
              <Checkbox
                checked={selectedAccountIds.includes(bankAccountID)}
                onChange={() => onAccountChange(bankAccountID)}
              />
            }
            label={
              <Typography variant="body1">
                {formatConnectedAccount(account)}
              </Typography>
            }
          />
        </ListItem>
      );
    })}
  </List>
);
